import { EARTH_RADIUS, Marcacion, RELACION_KM_METROS } from "src/utils";

// distancia entre dos coordenadas
export function distanciaEntreCoordenadas(
  lat1: number,
  lon1: number,
  lat2: number,
  lon2: number
) {
  const dLat = deg2rad(lat2 - lat1);
  const dLon = deg2rad(lon2 - lon1);

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) *
      Math.cos(deg2rad(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const d = EARTH_RADIUS * c * RELACION_KM_METROS; // Distancia en metros

  return d;
}

export function deg2rad(deg: number) {
  return deg * (Math.PI / 180);
}

export function ordenarMarcacionesPorDistancia(a: Marcacion, b: Marcacion) {
  return a.distancia - b.distancia;
}
